import { render, staticRenderFns } from "./RemoveTagConfig.vue?vue&type=template&id=4a2feec8&scoped=true"
import script from "./RemoveTagConfig.vue?vue&type=script&lang=js"
export * from "./RemoveTagConfig.vue?vue&type=script&lang=js"
import style0 from "./RemoveTagConfig.vue?vue&type=style&index=0&id=4a2feec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2feec8",
  null
  
)

export default component.exports